document.addEventListener('DOMContentLoaded', function () {
  const toggleButton = document.querySelector('.b2b-cart__button');
  const closeButton = document.querySelector('.b2b-cart-close-button');
  const cartDrawer = document.querySelector('.b2b-cart-drawer');

  if (toggleButton && cartDrawer) {
    toggleButton.addEventListener('click', () => {
      cartDrawer.classList.toggle('open');
    });
  }

  if (closeButton && cartDrawer) {
    closeButton.addEventListener('click', () => {
      cartDrawer.classList.remove('open');
    });
  }

  const cart = document.querySelector('.cart-icon__wrapper');
  const cartdrawer = document.querySelector('.b2b-cart-drawer');

  if (!cart || !cartdrawer) return;

  let isDragging = false;
  let startY, startTop;
  let dragDistance = 0;

  const cartHeight = cart.offsetHeight || 60;

  const initialTop = (window.innerHeight - cartHeight) / 2;
  cart.style.top = `${initialTop}px`;
  cartdrawer.style.top = `${initialTop}px`;

  const onDragStart = (y) => {
    isDragging = true;
    dragDistance = 0;
    startY = y;
    startTop = parseInt(window.getComputedStyle(cart).top, 10) || 0;
    cart.classList.add('dragging');
    cart.style.transition = 'none';
  };

  const onDragMove = (y) => {
    if (!isDragging) return;
    const deltaY = y - startY;
    dragDistance += Math.abs(deltaY);

    let newTop = startTop + deltaY;
    const minTop = 0;
    const maxTop = window.innerHeight - (cart.offsetHeight || cartHeight);
    newTop = Math.max(minTop, Math.min(maxTop, newTop));

    cart.style.top = `${newTop}px`;
    cartdrawer.style.top = `${newTop}px`;
  };

  const onDragEnd = () => {
    if (!isDragging) return;
    isDragging = false;
    cart.classList.remove('dragging');
    cart.style.transition = 'top 0.2s ease';
  };

  cart.addEventListener('click', (e) => {
    if (dragDistance > 5) e.stopImmediatePropagation();
  });

  cart.addEventListener('mousedown', (e) => {
    onDragStart(e.clientY);
    e.preventDefault();
  });

  document.addEventListener('mousemove', (e) => onDragMove(e.clientY));
  document.addEventListener('mouseup', onDragEnd);

  cart.addEventListener('touchstart', (e) => {
    onDragStart(e.touches[0].clientY);
  }, { passive: true });

  document.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    onDragMove(e.touches[0].clientY);
    e.preventDefault();
  }, { passive: false });

  document.addEventListener('touchend', onDragEnd);
});


if (!customElements.get("bulk-form")) {

  const svg1 = `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 38 37" fill="none">
<path d="M19 0.171875C15.375 0.171875 11.8315 1.2468 8.81745 3.26072C5.8034 5.27464 3.45424 8.1371 2.06703 11.4861C0.679816 14.8352 0.316858 18.5203 1.02405 22.0756C1.73125 25.6309 3.47683 28.8967 6.04007 31.4599C8.6033 34.0232 11.8691 35.7688 15.4244 36.476C18.9797 37.1832 22.6649 36.8202 26.0139 35.433C29.3629 34.0458 32.2254 31.6966 34.2393 28.6826C36.2532 25.6685 37.3281 22.125 37.3281 18.5C37.3224 13.6408 35.3896 8.98232 31.9536 5.54636C28.5177 2.11041 23.8592 0.177582 19 0.171875ZM19 34.6719C15.8015 34.6719 12.6748 33.7234 10.0154 31.9464C7.35595 30.1694 5.28315 27.6437 4.05914 24.6887C2.83513 21.7337 2.51488 18.4821 3.13887 15.345C3.76287 12.208 5.30309 9.32644 7.56477 7.06476C9.82644 4.80308 12.708 3.26286 15.845 2.63886C18.9821 2.01487 22.2337 2.33512 25.1887 3.55914C28.1437 4.78315 30.6694 6.85594 32.4464 9.51539C34.2234 12.1748 35.1719 15.3015 35.1719 18.5C35.1671 22.7876 33.4618 26.8982 30.43 29.93C27.3982 32.9618 23.2876 34.6671 19 34.6719ZM27.2656 18.5C27.2656 18.7859 27.152 19.0602 26.9499 19.2624C26.7477 19.4645 26.4734 19.5781 26.1875 19.5781H20.0781V25.6875C20.0781 25.9734 19.9645 26.2477 19.7624 26.4499C19.5602 26.652 19.2859 26.7656 19 26.7656C18.7141 26.7656 18.4398 26.652 18.2377 26.4499C18.0355 26.2477 17.9219 25.9734 17.9219 25.6875V19.5781H11.8125C11.5266 19.5781 11.2523 19.4645 11.0502 19.2624C10.848 19.0602 10.7344 18.7859 10.7344 18.5C10.7344 18.2141 10.848 17.9398 11.0502 17.7377C11.2523 17.5355 11.5266 17.4219 11.8125 17.4219H17.9219V11.3125C17.9219 11.0266 18.0355 10.7523 18.2377 10.5502C18.4398 10.348 18.7141 10.2344 19 10.2344C19.2859 10.2344 19.5602 10.348 19.7624 10.5502C19.9645 10.7523 20.0781 11.0266 20.0781 11.3125V17.4219H26.1875C26.4734 17.4219 26.7477 17.5355 26.9499 17.7377C27.152 17.9398 27.2656 18.2141 27.2656 18.5Z" fill="#054A91"/>
</svg>`;

  const svg2 = `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
<path d="M15 0.375C12.1075 0.375 9.27986 1.23274 6.87479 2.83976C4.46972 4.44677 2.5952 6.73089 1.48827 9.40325C0.381337 12.0756 0.091713 15.0162 0.656022 17.8532C1.22033 20.6902 2.61323 23.2961 4.65857 25.3414C6.70391 27.3868 9.30984 28.7797 12.1468 29.344C14.9838 29.9083 17.9244 29.6187 20.5968 28.5117C23.2691 27.4048 25.5532 25.5303 27.1602 23.1252C28.7673 20.7201 29.625 17.8926 29.625 15C29.6209 11.1225 28.0788 7.40492 25.3369 4.66309C22.5951 1.92125 18.8775 0.379095 15 0.375ZM21.4209 12.4209L13.5459 20.2959C13.4415 20.4005 13.3174 20.4847 13.1813 20.5436C13.0452 20.6026 12.8995 20.6352 12.751 20.6394C12.6024 20.6436 12.454 20.6193 12.3169 20.5681C12.1798 20.5169 12.0579 20.4401 11.959 20.3439L7.87501 16.2599C7.77615 16.161 7.69935 16.0392 7.64813 15.9029C7.5969 15.7665 7.57227 15.6195 7.5764 15.4713C7.58054 15.3231 7.61341 15.1772 7.67224 15.0413C7.73108 14.9054 7.81589 14.781 7.92039 14.6765C8.02489 14.572 8.14913 14.491 8.2855 14.4396C8.42186 14.3883 8.56671 14.3679 8.71076 14.3803C8.85481 14.3927 8.99362 14.4379 9.11454 14.5122L12.5635 16.6968L20.4306 8.82966C20.5416 8.71867 20.6828 8.66491 20.8288 8.6844C20.9747 8.7039 21.1107 8.79545 21.2041 8.93516C21.2976 9.07487 21.3372 9.24411 21.311 9.40895C21.2848 9.57379 21.1944 9.72019 21.056 9.8164L21.4209 12.4209Z" fill="#054A91"/>
</svg>`;

  class BulkForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListeners();
      this.initEvent();
    }

    initEvent() {}

    addEventListeners() {
      const form = this.querySelector("#bulk-data-form");
      const bulkFormWrapper = this.querySelector(".bulk-form__wrapper");
      const bulkFormInner = this.querySelector(".bulk-form__inner");
      const customizerCloseButton = this.querySelector(".bulk-form__inner .customizer_close");
      const dropdownBtn = this.querySelector(".dropdown-btn");
      const bulkFormPopup = this.querySelector(".bulk-form__body");
      const dropdownContainer = this.querySelector(".dropdown-container");
      this.ContactFormCountryCode = this.querySelector('#ContactFormCountryCode');
      this.phoneInput = this.querySelector("#ContactFormPhone");
      this.dropdownContent = this.querySelector(".dropdown-content");
      this.dropdownBtnText = this.querySelector(".dropdown-btn-text");
      this.captchaCode = this.querySelector(".captcha-code");
      this.captcha = this.querySelector(".captcha-container input");
      this.captchaRefresh = this.querySelector(".captcha-refresh");

      form.addEventListener("submit", (e) => {
        e.preventDefault();
        this.handleFormSubmit(form);
      });

      const checkboxes = document.querySelectorAll('.b2b-product-check');
      const wholeSaleProduct = document.querySelectorAll(".whole-sale-product-list");
      const productWrapper = document.querySelector('.b2b-product__wrapper');

      function updateWrapper() {
        if (!productWrapper) return;

        productWrapper.innerHTML = '';

        checkboxes.forEach(checkbox => {
          if (checkbox.checked) {
            const title = checkbox.value.trim();
            const imageUrl = checkbox.dataset.image;

            const productDiv = document.createElement('div');
            productDiv.classList.add('selected-product');

            if (imageUrl) {
              const imgEl = document.createElement('img');
              imgEl.src = imageUrl;
              imgEl.alt = title;
              imgEl.classList.add('b2b-product-image');
              productDiv.appendChild(imgEl);
            }

            const infoDiv = document.createElement('div');
            infoDiv.classList.add('b2b-product-info');
            infoDiv.innerHTML = `<div class="product-title">${title}</div>`;
            productDiv.appendChild(infoDiv);

            productWrapper.appendChild(productDiv);
          }
        });
      }

      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', () => {
          const checkedItem = checkbox.value.trim();

          wholeSaleProduct.forEach(product => {
            const productInfo = product.querySelector('.product-card__info a');
            const productTitle = productInfo?.textContent?.trim();

            if (productTitle === checkedItem) {
              const productInfoBlock = product.querySelector('.product-card__info');
              const atcButton = productInfoBlock?.querySelector(".b2b-atc-button");
              if (atcButton) {
                atcButton.innerHTML = checkbox.checked ? svg2 : svg1;
              }
            }
          });

          updateWrapper();
        });
      });

      customizerCloseButton.addEventListener("click", () => {
        this.hideBulkForm();

        const checkedItems = Array.from(this.dropdownContent.querySelectorAll('input[name="Products"]:checked'))
          .map(input => input.value);
        if (checkedItems.length > 0) {
          this.dropdownBtnText.innerHTML = checkedItems.join('<br>');
        } else {
          this.dropdownBtnText.innerHTML = "Enquire more products";
        }
      });

      dropdownBtn?.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleDropdown();
      });

      this.captchaRefresh.addEventListener("click", (e) => {
        this.generateCode();
      });

      bulkFormPopup.addEventListener("click", (e) => {
        if (!dropdownContainer?.contains(e.target)) {
          this.clearDropdown();
          this.dropdownContent?.classList.add("hidden");
        }
      });

      bulkFormWrapper.addEventListener("click", (e) => {
        if (!bulkFormInner.contains(e.target)) {
          this.hideBulkForm();
        }
      });

      this.phoneInput.addEventListener('keydown', (e) => {
        this.phoneNumberValidation(e);
      });

      this.ContactFormCountryCode.addEventListener('keydown', (e) => {
        this.countryCodeValidation(e);
      });

      this.generateCode();
    }

    async handleFormSubmit(form) {

      const honeypot = form.querySelector('input[name="hidden_field"]');
      if (honeypot && honeypot.value.trim() !== "") {
        return;
      }

      const ContactFormPhone = this.querySelector("#ContactFormPhone");
      const errorMsg = this.querySelector(".bulk-form__error-msg");

      // ✅ FIXED: accepts 6-15 digit international phone numbers
      const phoneRegex = /^\d{6,15}$/;

      if (this.captcha.value !== this.captchaCode.innerHTML) {
        this.generateCode();
        this.captcha.value = '';
        this.captcha.classList.add("bulk-form__validation");
        return;
      } else {
        this.captcha.classList.remove("bulk-form__validation");
      }

      if (!phoneRegex.test(ContactFormPhone.value)) {
        errorMsg.classList.remove("hidden");
        errorMsg.querySelector("span").innerHTML = "Invalid phone number";
        return;
      } else {
        errorMsg.classList.add("hidden");
      }

      const checkboxes = this.querySelectorAll('input[name="Products"]:checked');
      const selectedProducts = Array.from(checkboxes).map(checkbox => checkbox.value);

      if (selectedProducts.length === 0) {
        errorMsg.classList.remove("hidden");
        errorMsg.querySelector("span").innerHTML = "Please select at least one product.";
        return;
      }

      const hiddenProductInput = this.querySelector('#bulkFormproduct');
      hiddenProductInput.value = selectedProducts.join(', ');

      const bulkSubmitText = this.querySelector(".bulk-button__text");
      const bulkSubmitLoader = this.querySelector(".bulk-button__loader");
      bulkSubmitText.classList.add("hidden");
      bulkSubmitLoader.classList.remove("hidden");

      const data = new FormData(form);
      const action = form.action;

      data.append('captcha_answer', this.captchaCode.innerHTML);

      let message = data.get('Message');
      data.delete('Message');
      data.append('Message', message.length === 0 ? "NA" : message);

      let phoneNumber = data.get('Phone');
      data.delete('Phone');
      let combinedPhoneNumber = "+" + this.ContactFormCountryCode.value + phoneNumber;
      data.append('Phone', combinedPhoneNumber);

      try {
        const response = await fetch(action, {
          method: "POST",
          body: data,
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const itemCountEl = document.querySelector('.b2b-item-count');
        const totalItemEl = document.querySelector('.b2b-total-item');
        if (itemCountEl) itemCountEl.innerHTML = 0;
        if (totalItemEl) totalItemEl.innerHTML = 0;

        this.querySelector(".bulk-form__body").classList.add("hidden");
        this.querySelector(".bulk-form__success-msg").classList.remove("hidden");

        bulkSubmitText.classList.remove("hidden");
        bulkSubmitLoader.classList.add("hidden");

        this.clearBulkForm(form);

        document.querySelectorAll(".b2b-atc-button").forEach((button) => {
          button.innerHTML = svg1;
          button.dataset.state = "default";
        });

        const productWrapper = document.querySelector('.b2b-product__wrapper');
        if (productWrapper) {
          productWrapper.innerHTML = '';
          const continueBtn = document.createElement('button');
          continueBtn.textContent = 'Continue Shopping';
          continueBtn.classList.add('continue-shopping-btn');
          continueBtn.setAttribute('aria-label', 'Continue shopping');
          continueBtn.addEventListener('click', () => location.reload());
          productWrapper.appendChild(continueBtn);
        }

      } catch (error) {
        console.error("Error:", error);
        alert("Something went wrong, please try again later.");
      }
    }

    phoneNumberValidation(event) {
      const key = event.key;
      const errorMsg = this.querySelector(".bulk-form__error-msg");

      if (key === "Backspace" || key === "ArrowLeft" || key === "ArrowRight" || key === "Tab") {
        return;
      }
      if (!/^[0-9]$/.test(key)) {
        event.preventDefault();
      }
      // ✅ FIXED: hide error once 6+ digits entered
      if (this.phoneInput.value.length >= 6) {
        errorMsg.classList.add("hidden");
      }
      // ✅ FIXED: allow up to 15 digits for international numbers
      if (this.phoneInput.value.length >= 15) {
        event.preventDefault();
      }
    }

    countryCodeValidation(event) {
      const key = event.key;
      if (key === "Backspace" || key === "ArrowLeft" || key === "ArrowRight" || key === "Tab") {
        return;
      }
      if (!/^[0-9]$/.test(key)) {
        event.preventDefault();
      }
    }

    clearBulkForm(form) {
      const elements = form.elements;
      for (let i = 0; i < elements.length; i++) {
        let element = elements[i];
        if (element.type === "checkbox") {
          element.checked = false;
          element.closest('label')?.classList.remove("hidden");
        } else if (element.type !== "submit") {
          element.value = "";
        }
      }
      const itemCountEl = document.querySelector('.b2b-item-count');
      const totalItemEl = document.querySelector('.b2b-total-item');
      if (itemCountEl) itemCountEl.innerHTML = 0;
      if (totalItemEl) totalItemEl.innerHTML = 0;
    }

    hideBulkForm() {
      const errorMsg = this.querySelector(".bulk-form__error-msg");
      document.body.classList.remove("overflow-hidden");
      this.classList.toggle("hidden");
      this.querySelector(".bulk-form__body").classList.remove("hidden");
      this.querySelector(".bulk-form__success-msg").classList.add("hidden");
      errorMsg.classList.add("hidden");
      this.dropdownContent?.classList.add("hidden");
      this.generateCode();
      this.captcha.classList.remove("bulk-form__validation");
    }

    toggleDropdown() {
      this.clearDropdown();
      this.dropdownContent.classList.toggle("hidden");
    }

    clearDropdown() {
      const isOpen = !this.dropdownContent.classList.contains("hidden");
      if (isOpen) {
        const checkedItems = Array.from(this.dropdownContent.querySelectorAll('input[name="Products"]:checked'))
          .map(input => input.value);

        if (checkedItems.length > 0) {
          this.dropdownBtnText.innerHTML = checkedItems.join('<br>');
        } else {
          this.dropdownBtnText.innerHTML = "Enquire more products";
        }
      }
    }

    generateCode() {
      let uniquechar = "";
      const randomchar = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 5; i++) {
        uniquechar += randomchar.charAt(Math.floor(Math.random() * randomchar.length));
      }
      this.captchaCode.innerHTML = uniquechar;
    }
  }

  customElements.define("bulk-form", BulkForm);
}


if (!customElements.get("b2b-atc")) {
  const CART_STORAGE_KEY = 'b2b-selected-products';

  function saveSelectedProducts(selectedTitles) {
    localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(selectedTitles));
  }

  function loadSelectedProducts() {
    const saved = localStorage.getItem(CART_STORAGE_KEY);
    return saved ? JSON.parse(saved) : [];
  }

  class B2BAtc extends HTMLElement {
    constructor() {
      super();
      this.handleButtonClick = this.handleButtonClick.bind(this);
      this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    }

    connectedCallback() {
      this.bulkFormEl = document.querySelector("bulk-form");
      if (!this.bulkFormEl) return;

      this.dropdownText = this.bulkFormEl.querySelector(".dropdown-btn-text");
      const clearAllButton = document.querySelector('.b2b-clear-all');
      if (clearAllButton) {
        clearAllButton.addEventListener('click', () => this.clearAllProducts());
      }

      this.querySelectorAll(".b2b-atc-button").forEach((button) => {
        button.addEventListener("click", this.handleButtonClick);
      });

      this.bulkFormEl.querySelectorAll('input[name="Products"]').forEach((checkbox) => {
        checkbox.addEventListener("change", this.handleCheckboxChange);
      });

      const savedTitles = loadSelectedProducts();
      if (savedTitles.length && this.bulkFormEl) {
        savedTitles.forEach(title => {
          const checkbox = this.bulkFormEl.querySelector(`input[name="Products"][value="${title}"]`);
          if (checkbox) checkbox.checked = true;

          const button = this.querySelector(`.b2b-atc-button[data-product="${title}"]`);
          if (button) {
            button.innerHTML = this.getSvg2();
            button.dataset.state = "active";
          }
        });

        this.updateDropdownText();
        this.updateProductWrapper();
      }
    }

    disconnectedCallback() {
      this.querySelectorAll(".b2b-atc-button").forEach((button) => {
        button.removeEventListener("click", this.handleButtonClick);
      });

      if (this.bulkFormEl) {
        this.bulkFormEl.querySelectorAll('input[name="Products"]').forEach((checkbox) => {
          checkbox.removeEventListener("change", this.handleCheckboxChange);
        });
      }
    }

    handleButtonClick(event) {
      const button = event.currentTarget;
      const isDefault = button.dataset.state === "default";
      const productTitle = button.dataset.product?.trim();

      if (!productTitle || !this.bulkFormEl) return;

      const checkbox = this.bulkFormEl.querySelector(`input[name="Products"][value="${productTitle}"]`);
      if (!checkbox) return;

      checkbox.checked = isDefault;
      button.innerHTML = isDefault ? this.getSvg2() : this.getSvg1();
      button.dataset.state = isDefault ? "active" : "default";

      this.updateDropdownText();
      this.updateProductWrapper();
      this.updateItemCount();

      const selectedTitles = Array.from(this.bulkFormEl.querySelectorAll('input[name="Products"]:checked'))
        .map(input => input.value.trim());

      saveSelectedProducts(selectedTitles);
    }

    handleCheckboxChange(event) {
      this.updateDropdownText();
      this.updateProductWrapper();
      this.updateItemCount();

      const selectedTitles = Array.from(this.bulkFormEl.querySelectorAll('input[name="Products"]:checked'))
        .map(input => input.value.trim());

      saveSelectedProducts(selectedTitles);
    }

    updateItemCount() {
      const itemCountEl = document.querySelector('.b2b-item-count');
      const totalItemEl = document.querySelector('.b2b-total-item');

      if (!this.bulkFormEl) return;

      const checkedInputs = this.bulkFormEl.querySelectorAll('input[name="Products"]:checked');
      const count = checkedInputs.length;

      if (itemCountEl) itemCountEl.textContent = count;
      if (totalItemEl) totalItemEl.textContent = count;
    }

    clearAllProducts() {
      if (!this.bulkFormEl) return;

      const checkboxes = this.bulkFormEl.querySelectorAll('input[name="Products"]');
      checkboxes.forEach(input => {
        input.checked = false;
      });

      this.querySelectorAll('.b2b-atc-button').forEach(button => {
        button.innerHTML = this.getSvg1();
        button.dataset.state = "default";
      });

      const productWrapper = document.querySelector('.b2b-product__wrapper');
      if (productWrapper) {
        productWrapper.innerHTML = '';
        const continueBtn = document.createElement('button');
        continueBtn.textContent = 'Continue Shopping';
        continueBtn.classList.add('continue-shopping-btn');
        continueBtn.setAttribute('aria-label', 'Continue shopping');
        continueBtn.addEventListener('click', () => location.reload());
        productWrapper.appendChild(continueBtn);
      }

      this.updateDropdownText();
      this.updateItemCount();

      document.querySelectorAll('.cart-item-quantity').forEach(input => {
        input.value = 0;
      });

      saveSelectedProducts([]);
    }

    updateProductWrapper() {
      const productWrapper = document.querySelector('.b2b-product__wrapper');
      if (!productWrapper || !this.bulkFormEl) return;

      const checkedInputs = this.bulkFormEl.querySelectorAll('input[name="Products"]:checked');
      productWrapper.innerHTML = '';

      checkedInputs.forEach((input) => {
        const title = input.value.trim();
        const imageUrl = input.dataset.image;

        const productDiv = document.createElement('div');
        productDiv.classList.add('selected-product');
        productDiv.dataset.title = title;

        if (imageUrl) {
          const imgEl = document.createElement('img');
          imgEl.src = imageUrl;
          imgEl.alt = title;
          imgEl.classList.add('b2b-product-image');
          productDiv.appendChild(imgEl);
        }

        this.updateItemCount();

        const infoEl = document.createElement('div');
        infoEl.classList.add('b2b-product-info');
        infoEl.innerHTML = `<div class="product-title">${title}</div>`;
        productDiv.appendChild(infoEl);

        const removeBtn = document.createElement('button');
        removeBtn.classList.add('remove-btn');
        removeBtn.innerHTML = '&times;';
        removeBtn.setAttribute('aria-label', 'Remove product');
        removeBtn.addEventListener('click', () => {
          this.removeProduct(title);
        });

        productDiv.appendChild(removeBtn);
        productWrapper.appendChild(productDiv);
      });
    }

    removeProduct(productTitle) {
      const checkbox = this.bulkFormEl.querySelector(`input[name="Products"][value="${productTitle}"]`);
      if (checkbox) {
        checkbox.checked = false;
        checkbox.dispatchEvent(new Event('change'));
      }

      const atcButton = document.querySelector(`.b2b-atc-button[data-product="${productTitle}"]`);
      if (atcButton) {
        atcButton.innerHTML = this.getSvg1();
        atcButton.dataset.state = "default";
      }

      const selectedTitles = Array.from(this.bulkFormEl.querySelectorAll('input[name="Products"]:checked'))
        .map(input => input.value.trim());

      saveSelectedProducts(selectedTitles);
      this.updateItemCount();

      if (selectedTitles.length === 0) {
        const productWrapper = document.querySelector('.b2b-product__wrapper');
        if (productWrapper) {
          const continueBtn = document.createElement('button');
          continueBtn.textContent = 'Continue Shopping';
          continueBtn.classList.add('continue-shopping-btn');
          continueBtn.setAttribute('aria-label', 'Continue shopping');
          continueBtn.addEventListener('click', () => location.reload());
          productWrapper.appendChild(continueBtn);
        }
      }
    }

    updateDropdownText() {
      if (!this.dropdownText) return;

      const checkedItems = Array.from(
        this.bulkFormEl.querySelectorAll('input[name="Products"]:checked')
      ).map((input) => input.value.trim());

      this.dropdownText.innerHTML = checkedItems.length > 0
        ? checkedItems.join("<br>")
        : "Enquire more products";
    }

    getSvg1() {
      return `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 38 37" fill="none">
<path d="M19 0.171875C15.375 0.171875 11.8315 1.2468 8.81745 3.26072C5.8034 5.27464 3.45424 8.1371 2.06703 11.4861C0.679816 14.8352 0.316858 18.5203 1.02405 22.0756C1.73125 25.6309 3.47683 28.8967 6.04007 31.4599C8.6033 34.0232 11.8691 35.7688 15.4244 36.476C18.9797 37.1832 22.6649 36.8202 26.0139 35.433C29.3629 34.0458 32.2254 31.6966 34.2393 28.6826C36.2532 25.6685 37.3281 22.125 37.3281 18.5C37.3224 13.6408 35.3896 8.98232 31.9536 5.54636C28.5177 2.11041 23.8592 0.177582 19 0.171875ZM19 34.6719C15.8015 34.6719 12.6748 33.7234 10.0154 31.9464C7.35595 30.1694 5.28315 27.6437 4.05914 24.6887C2.83513 21.7337 2.51488 18.4821 3.13887 15.345C3.76287 12.208 5.30309 9.32644 7.56477 7.06476C9.82644 4.80308 12.708 3.26286 15.845 2.63886C18.9821 2.01487 22.2337 2.33512 25.1887 3.55914C28.1437 4.78315 30.6694 6.85594 32.4464 9.51539C34.2234 12.1748 35.1719 15.3015 35.1719 18.5C35.1671 22.7876 33.4618 26.8982 30.43 29.93C27.3982 32.9618 23.2876 34.6671 19 34.6719ZM27.2656 18.5C27.2656 18.7859 27.152 19.0602 26.9499 19.2624C26.7477 19.4645 26.4734 19.5781 26.1875 19.5781H20.0781V25.6875C20.0781 25.9734 19.9645 26.2477 19.7624 26.4499C19.5602 26.652 19.2859 26.7656 19 26.7656C18.7141 26.7656 18.4398 26.652 18.2377 26.4499C18.0355 26.2477 17.9219 25.9734 17.9219 25.6875V19.5781H11.8125C11.5266 19.5781 11.2523 19.4645 11.0502 19.2624C10.848 19.0602 10.7344 18.7859 10.7344 18.5C10.7344 18.2141 10.848 17.9398 11.0502 17.7377C11.2523 17.5355 11.5266 17.4219 11.8125 17.4219H17.9219V11.3125C17.9219 11.0266 18.0355 10.7523 18.2377 10.5502C18.4398 10.348 18.7141 10.2344 19 10.2344C19.2859 10.2344 19.5602 10.348 19.7624 10.5502C19.9645 10.7523 20.0781 11.0266 20.0781 11.3125V17.4219H26.1875C26.4734 17.4219 26.7477 17.5355 26.9499 17.7377C27.152 17.9398 27.2656 18.2141 27.2656 18.5Z" fill="#054A91"/>
</svg>`;
    }

    getSvg2() {
      return `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
<path d="M15 0.375C12.1075 0.375 9.27986 1.23274 6.87479 2.83976C4.46972 4.44677 2.5952 6.73089 1.48827 9.40325C0.381337 12.0756 0.091713 15.0162 0.656022 17.8532C1.22033 20.6902 2.61323 23.2961 4.65857 25.3414C6.70391 27.3868 9.30984 28.7797 12.1468 29.344C14.9838 29.9083 17.9244 29.6187 20.5968 28.5117C23.2691 27.4048 25.5532 25.5303 27.1602 23.1252C28.7673 20.7201 29.625 17.8926 29.625 15C29.6209 11.1225 28.0788 7.40492 25.3369 4.66309C22.5951 1.92125 18.8775 0.379095 15 0.375ZM21.4209 12.4209L13.5459 20.2959C13.4415 20.4005 13.3174 20.4847 13.1813 20.5436C13.0452 20.6026 12.8995 20.6352 12.751 20.6394C12.6024 20.6436 12.454 20.6193 12.3169 20.5681C12.1798 20.5169 12.0579 20.4401 11.959 20.3439L7.87501 16.2599C7.77615 16.161 7.69935 16.0392 7.64813 15.9029C7.5969 15.7665 7.57227 15.6195 7.5764 15.4713C7.58054 15.3231 7.61341 15.1772 7.67224 15.0413C7.73108 14.9054 7.81589 14.781 7.92039 14.6765C8.02489 14.572 8.14913 14.491 8.2855 14.4396C8.42186 14.3883 8.56671 14.3679 8.71076 14.3803C8.85481 14.3927 8.99362 14.4379 9.11454 14.5122L12.5635 16.6968L20.4306 8.82966C20.5416 8.71867 20.6828 8.66491 20.8288 8.6844C20.9747 8.7039 21.1107 8.79545 21.2041 8.93516C21.2976 9.07487 21.3372 9.24411 21.311 9.40895C21.2848 9.57379 21.1944 9.72019 21.056 9.8164L21.4209 12.4209Z" fill="#054A91"/>
</svg>`;
    }
  }

  customElements.define("b2b-atc", B2BAtc);
}